// extracted by mini-css-extract-plugin
export default {"page":"Confirmation_page__GrgQc","content_wrapper":"Confirmation_content_wrapper__g0XS2","text":"Confirmation_text__knhEf"};